import request from '@/Network/Requests/request'
import Service from '@/Network/Services/Service'
import { NpsFilterOption } from '@/Network/Types/Responses/NpsResponses'

export default class NpsConfigService extends Service {
  prefix: string

  constructor() {
    super()
    this.prefix = '/nps/config'
  }

  /**
   * Selects das telas de configuração do NPS (Associações / Avaliadores / Enquetes /
   * Avaliação). Usam rotas de grão NPS (`nps_settings_managing`) em vez das rotas admin de
   * outros domínios (schedules/healthUnits/companies `list-admin`), que exigiam papéis fora
   * do NPS e devolviam 403 para quem só tinha permissão de NPS. Carregamento não-crítico →
   * fallback silencioso para [].
   */
  async listConfigHealthUnits(): Promise<NpsFilterOption[]> {
    try {
      const { data } = await request.get<NpsFilterOption[]>(
        `${this.getCompletePath()}/filters/health-units`
      )
      return data
    } catch {
      return []
    }
  }

  async listConfigSchedules(): Promise<NpsFilterOption[]> {
    try {
      const { data } = await request.get<NpsFilterOption[]>(
        `${this.getCompletePath()}/filters/schedules`
      )
      return data
    } catch {
      return []
    }
  }

  /**
   * web#2695 — ao contrário dos dois métodos acima, o filtro de empresa precisa
   * distinguir "sem empresas" de "falha ao carregar" (ex.: 403 de permissão) para o
   * consumidor exibir o estado certo. Segue o padrão canônico (`error-handling.md`):
   * o service lança, o componente exibe.
   */
  async listConfigCompanies(): Promise<NpsFilterOption[]> {
    try {
      const { data } = await request.get<NpsFilterOption[]>(
        `${this.getCompletePath()}/filters/companies`
      )
      return data
    } catch (e) {
      throw this.handleError(e, 'Não foi possível carregar as empresas')
    }
  }
}
